/**
 * A refused `PUT` / `DELETE …/users/:userId/license`. `message` is the reason
 * platform-access-service gave; `code` is its error code, when it has one.
 */
export class UserLicenseRequestError extends Error {
  constructor(
    message: string,
    public readonly code?: string
  ) {
    super(message)
  }
}
